import { render } from "./TripsItem.vue?vue&type=template&id=cb5569f0"
import script from "./TripsItem.vue?vue&type=script&lang=js"
export * from "./TripsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__